// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useMemo, useEffect, useState, useCallback, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setIsEditPreferencesSuccess } from '../../../store/accountSettings/AccountSettingsActions'
import { editPreferencesSettings } from '../../../store/accountSettings/AccountSettingsThunk'
import { setNewProviderProfileSettings } from '../../../store/waitingRoom/WaitingRoomActions'
import {
  CHOOSE_MESSAGES_TO_RECEIVE_ON_MOBILE_TEXT,
  ENDED_VISITS_REMINDER_TEXT,
  LAST_MINUTE_BOOKING_ALERT_TEXT,
  PATIENT_JOINED_WAITING_ROOM_TEXT,
  SMS_MESSAGING_TEXT,
  UPCOMING_SHIFT_TEXT,
} from '../../../utils/constants'
import { AccountSettingsSection } from '../AccountSettingsSection/AccountSettingsSection'
import { PreferencesToggle } from './components/PreferencesToggle/PreferencesToggle'

const getSettingsConfig = (
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  upcomingShiftActiveValue,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  patientEnteredValue,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  endVisitReminderValue,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  lastMinuteBookingValue,
) => ({
  IsNotificationUpcomingShiftAllowed: upcomingShiftActiveValue,
  IsNotificationPatientEnteredWaitingRoomAllowed: patientEnteredValue,
  IsNotificationEndedVisitReminderAllowed: endVisitReminderValue,
  IsLastMinuteBookingReminderAllowed: lastMinuteBookingValue,
})

const editToggleValuesConfig = {
  UPCOMING_SHIFT: 'UPCOMING_SHIFT',
  PATIENT_JOINED: 'PATIENT_JOINED',
  END_VISIT_REMINDER: 'END_VISIT_REMINDER',
  LAST_MINUTE_BOOKING: 'LAST_MINUTE_BOOKING',
}

export const PreferencesSection = memo(() => {
  const dispatch = useDispatch()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profileSettings = useSelector((state) => state.waitingRoomReducer.providerProfile.Settings)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isEditPreferencesSuccess = useSelector((state) => state.accountSettings.isEditPreferencesSuccess)

  const [editToggleValue, setEditToggleValue] = useState('')
  const [isUpcomingShiftActive, setIsUpcomingShiftActive] = useState(profileSettings.IsNotificationUpcomingShiftAllowed)
  const [isPatientJoinedActive, setIsPatientJoinedActive] = useState(
    profileSettings.IsNotificationPatientEnteredWaitingRoomAllowed,
  )
  const [isEndedVisitReminderActive, setIsEndedVisitReminderActive] = useState(
    profileSettings.IsNotificationEndedVisitReminderAllowed,
  )
  const [isLastMinuteBookingActive, setIsLastMinuteBookingActive] = useState(
    profileSettings.IsLastMinuteBookingReminderAllowed,
  )

  useEffect(() => {
    setIsUpcomingShiftActive(profileSettings.IsNotificationUpcomingShiftAllowed)
    setIsPatientJoinedActive(profileSettings.IsNotificationPatientEnteredWaitingRoomAllowed)
    setIsEndedVisitReminderActive(profileSettings.IsNotificationEndedVisitReminderAllowed)
    setIsLastMinuteBookingActive(profileSettings.IsLastMinuteBookingReminderAllowed)
  }, [profileSettings])

  useEffect(() => {
    if (isEditPreferencesSuccess) {
      const upcomingShiftToggleValue =
        editToggleValue === editToggleValuesConfig.UPCOMING_SHIFT ? !isUpcomingShiftActive : isUpcomingShiftActive

      const patientJoinedToggleValue =
        editToggleValue === editToggleValuesConfig.PATIENT_JOINED ? !isPatientJoinedActive : isPatientJoinedActive

      const endedVisitReminderToggleValue =
        editToggleValue === editToggleValuesConfig.END_VISIT_REMINDER ?
          !isEndedVisitReminderActive
        : isEndedVisitReminderActive

      const lastMinuteBookingToggleValue =
        editToggleValue === editToggleValuesConfig.LAST_MINUTE_BOOKING ?
          !isLastMinuteBookingActive
        : isLastMinuteBookingActive

      dispatch(setIsEditPreferencesSuccess())
      dispatch(
        setNewProviderProfileSettings(
          getSettingsConfig(
            upcomingShiftToggleValue,
            patientJoinedToggleValue,
            endedVisitReminderToggleValue,
            lastMinuteBookingToggleValue,
          ),
        ),
      )
    }
  }, [isEditPreferencesSuccess])

  const toggleUpcomingShift = useCallback(() => {
    setEditToggleValue(editToggleValuesConfig.UPCOMING_SHIFT)
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      editPreferencesSettings(
        getSettingsConfig(
          !isUpcomingShiftActive,
          isPatientJoinedActive,
          isEndedVisitReminderActive,
          isLastMinuteBookingActive,
        ),
      ),
    )
  }, [dispatch, isEndedVisitReminderActive, isPatientJoinedActive, isUpcomingShiftActive, isLastMinuteBookingActive])

  const togglePatientJoined = useCallback(() => {
    setEditToggleValue(editToggleValuesConfig.PATIENT_JOINED)
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      editPreferencesSettings(
        getSettingsConfig(
          isUpcomingShiftActive,
          !isPatientJoinedActive,
          isEndedVisitReminderActive,
          isLastMinuteBookingActive,
        ),
      ),
    )
  }, [dispatch, isEndedVisitReminderActive, isPatientJoinedActive, isUpcomingShiftActive, isLastMinuteBookingActive])

  const toggleEndedVisitReminder = useCallback(() => {
    setEditToggleValue(editToggleValuesConfig.END_VISIT_REMINDER)
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      editPreferencesSettings(
        getSettingsConfig(
          isUpcomingShiftActive,
          isPatientJoinedActive,
          !isEndedVisitReminderActive,
          isLastMinuteBookingActive,
        ),
      ),
    )
  }, [dispatch, isEndedVisitReminderActive, isPatientJoinedActive, isUpcomingShiftActive, isLastMinuteBookingActive])

  const toggleLastMinuteBooking = useCallback(() => {
    setEditToggleValue(editToggleValuesConfig.LAST_MINUTE_BOOKING)
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      editPreferencesSettings(
        getSettingsConfig(
          isUpcomingShiftActive,
          isPatientJoinedActive,
          isEndedVisitReminderActive,
          !isLastMinuteBookingActive,
        ),
      ),
    )
  }, [dispatch, isEndedVisitReminderActive, isPatientJoinedActive, isUpcomingShiftActive, isLastMinuteBookingActive])

  const togglesConfig = useMemo(
    () => [
      {
        isActive: isUpcomingShiftActive,
        setIsActive: toggleUpcomingShift,
        description: UPCOMING_SHIFT_TEXT,
      },
      {
        isActive: isPatientJoinedActive,
        setIsActive: togglePatientJoined,
        description: PATIENT_JOINED_WAITING_ROOM_TEXT,
      },
      {
        isActive: isEndedVisitReminderActive,
        setIsActive: toggleEndedVisitReminder,
        description: ENDED_VISITS_REMINDER_TEXT,
      },
      {
        isActive: isLastMinuteBookingActive,
        setIsActive: toggleLastMinuteBooking,
        description: LAST_MINUTE_BOOKING_ALERT_TEXT,
      },
    ],
    [
      isUpcomingShiftActive,
      toggleUpcomingShift,
      isPatientJoinedActive,
      togglePatientJoined,
      isEndedVisitReminderActive,
      toggleEndedVisitReminder,
      isLastMinuteBookingActive,
      toggleLastMinuteBooking,
    ],
  )

  return (
    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
    <AccountSettingsSection title={SMS_MESSAGING_TEXT} description={CHOOSE_MESSAGES_TO_RECEIVE_ON_MOBILE_TEXT}>
      {togglesConfig.map(({ isActive, setIsActive, description }, idx) => (
        <PreferencesToggle
          key={description}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          isActive={isActive}
          setIsActive={setIsActive}
          description={description}
          isTheLast={idx === togglesConfig.length - 1}
        />
      ))}
    </AccountSettingsSection>
  )
})
